<template>
	<div>
        <div>
			<span class="xbed-sub-title">管家即时账务列表</span>
		</div>
		<div class="xbed-breadcrumb">
			<Breadcrumb>
				<BreadcrumbItem>麗家会</BreadcrumbItem>
				<BreadcrumbItem>管家即时账务明细</BreadcrumbItem>
			</Breadcrumb>
		</div>

        <br>
		<Content>
            <Table :columns="keeperColumns" :data="keeperBillList" overflow="hidden"></Table>
        </Content>
        <br>

        <div class="xbed-breadcrumb" style="margin-top:30px;">
			<Breadcrumb>
				<BreadcrumbItem>本月收支明细</BreadcrumbItem>
			</Breadcrumb>
		</div>
        <br>
        
		<Content >
            <Form @submit.native.prevent="preventSubmit" inline>
                <Row>
                    <FormItem  label="项目:" :label-width="70">
                        <Select v-model="queryParams.project" placement="top" transfer filterable style="width:160px;">
                            <Option :value="-1">全部</Option>
                            <Option value="清洁基本薪酬">清洁基本薪酬</Option>
                            <Option value="系统超时扣费">系统超时扣费</Option>
                            <Option value="管家取消扣费">管家取消扣费</Option>
                            <Option value="值班单薪酬">值班单薪酬</Option>
                            <Option value="值班单超时扣罚">值班单超时扣罚</Option>
                            <Option value="评价奖励">评价奖励</Option>
                            <Option value="评价扣罚">评价扣罚</Option>
                            <Option value="人工录入平台奖励">人工录入平台奖励</Option>
                            <Option value="业主补贴">业主补贴</Option>
                            <Option value="福利补贴">福利补贴</Option>
                            <Option value="平台补贴">平台补贴</Option>
                        </Select>
                    </FormItem>

                    <FormItem label="清洁单号:" :label-width="80">
                        <Input type="text" v-model="queryParams.cleanOrderNo" ></Input>
                    </FormItem>

                    <FormItem label="清洁单来源:" :label-width="90">
                        <Select v-model="queryParams.cleanSource" placement="top" transfer filterable style="width:160px;">
                            <Option :value="-1">全部</Option>
                            <Option :value="-2">无清洁单来源</Option>
                            <Option v-for="source in sourceArrData" v-bind:value="source.value" :key="source.name">{{source.name}}</Option>
                        </Select>
                    </FormItem>

                    <FormItem label="状态:" :label-width="70">
                        <Select v-model="queryParams.isCancel" placement="top" transfer filterable style="width:100px;">
                            <Option :value="-1">全部</Option>
                            <Option :value="0">有效</Option>
                            <Option :value="1">已取消</Option>
                        </Select>
                    </FormItem>

                    <FormItem>
                        <Button type="primary" @click="getCleanerChargingBillDetails" :loading="queryBtn">查询</Button>
                    </FormItem>
                </Row>           
            </Form>
            <Table :columns="columns" :data="paydetailList" class="paydetailList"></Table>
            <div style="margin: 10px; overflow: hidden;">
                <Page show-sizer placement="top"
                :total="listTotal"
                :current="queryParams.page"
                :page-size="queryParams.rows"
                @on-page-size-change="changePageSize"
                @on-change="changePage"></Page>
            </div>
        </Content>

        <Modal class="cloth-washing-fee"
            v-model="entryRewardAndFineModal.display"
            ref="entryRewardFineModal"
            :loading="true"
            title="录入惩罚"
            width="650"
            :closable="false"
            ok-text="保存"
            @on-ok="confirmEntryRewardFineFn">
            <Form :label-width="100" ref="entryRewardFineModalForm" :rules="modalDataRules">
                <FormItem label="管家手机号" prop="cleanerAccount">
                    <Input v-model="entryRewardAndFineModal.data.cleanerAccount" :maxlength="11" placeholder="" disabled></Input>
                </FormItem>
                <FormItem label="金额(元)" prop="costMoney">
                    <Input v-model="entryRewardAndFineModal.data.costMoney"  placeholder=""></Input>
                </FormItem>
                <FormItem label="原因" prop="reason">
                    <Input v-model="entryRewardAndFineModal.data.reason" :maxlength="100" placeholder=""></Input>
                </FormItem>
            </Form>
        </Modal>
        
        <Modal class="cloth-washing-fee"
            v-model="cancelRewardFineModal.display"
            ref="cancelRewardFineModal"
            :loading="true"
            title="取消奖励/取消扣罚"
            width="650"
            :closable="false"
            ok-text="保存"
            @on-ok="cancelRewardFineFn">
            <Form :label-width="100" ref="cancelRewardFineModalForm" :rules="cacelModalRules">
                <FormItem label="取消原因" prop="reason">
                    <Input v-model="cancelRewardFineModal.data.reason" :maxlength="100" placeholder=""></Input>
                </FormItem>
            </Form>
        </Modal>
    </div>
</template>

<script>
import Moment from "moment";
import API from "@/api";
import Utils from "@/utils";

export default {
    data() {
        
        const entryRewardFineValidatelist = {
            cleanerAccount: ( rule, value, callback ) => {
                if (!this.entryRewardAndFineModal.data.cleanerAccount) {
                    callback( new Error( '手机号码不能为空' ) )
                } else {
                    callback();
                }
            },
            costMoney: ( rule, value, callback ) => {
                if (!this.entryRewardAndFineModal.data.costMoney) {
                    callback( new Error( '金额不能为空' ) )
                } else {
                    callback();
                }
            },
            reason: ( rule, value, callback ) => {
                if (!this.entryRewardAndFineModal.data.reason) {
                    callback( new Error( '原因不能为空' ) )
                } else {
                    callback();
                }
            },
        }
        const cancelRewardFineValidate = {
            reason: ( rule, value, callback ) => {
                if (!this.cancelRewardFineModal.data.reason) {
                    callback( new Error( '原因不能为空' ) )
                } else {
                    callback();
                }
            },
        }
		return{
            modalDataRules: {
                cleanerAccount: [
                    {validator: entryRewardFineValidatelist.cleanerAccount, required: true, trigger: 'blur'}
                ],
                costMoney: [
                    {validator: entryRewardFineValidatelist.costMoney, required: true, trigger: 'blur'}
                ],
                reason: [
                    {validator: entryRewardFineValidatelist.reason, required: true, trigger: 'blur'}
                ]
            },
            cacelModalRules: {
                reason: [
                    {validator: cancelRewardFineValidate.reason, required: true, trigger: 'blur'}
                ]
            },
			cleanerId: '',
			month:'',
            cancelRewardFineModal: {
                display: false,
                data: {
                    id: '',
                    reason: '',
                    operatorName: ''
                },
                initData: {
                    id: '',
                    reason: '',
                    operatorName: ''
                }
            },
            queryBtn: false,
            keeperBillList: [],
            keeperColumns: [
                {
                    title: '日期',
                    key: 'month',
                    align: 'center',
                    width: 180
                },
                {
                    title: '管家',
                    align: 'center',
                    width: 240,
                    render: (h,params) => {
						return h('div',params.row.cleanerId + "_" + params.row.cleanerName + "_" + params.row.cleanerAccount)
					}
                },
                {
                    title: '收入（元）',
                    key: 'incomeMoney',
                    align: 'center',
                    width: 160
                },
                {
                    title: '支出（元）',
                    key: 'expenditureMoney',
                    align: 'center',
                    width: 160
                },
                {
                    title: '汇总（元）',
                    key: 'totalMoney',
                    align: 'center',
                    width: 160
                },
                {
                    title: '操作',
                    align: 'center',
                    render: (h, params) => {
                        return h("div", [
                            h(
                                "Button",
                                {
                                    props: {
                                        type: "error",
                                        size: "small"
                                    },
                                    style: {
                                        marginLeft:'10px',
                                    },
                                    on: {
                                        click: () => {
                                            this.showEntryRewardAndFineModal()
                                            this.entryRewardAndFineModal.data.cleanerAccount = params.row.cleanerAccount
                                        }
                                    }
                                },
                                "录入奖惩"  
                            )
                        ])
                    }
                }
            ],
            entryRewardAndFineModal: {
                display: false,
                data: {
                    cleanerAccount: '',
                    costMoney: '',
                    reason: ''
                },
                initData: {
                    cleanerAccount: '',
                    costMoney: '',
                    reason: ''
                }
            },
			paydetailList: [],
			queryParams: {
				page: 1,
				rows: 10,
				cleanerId: "",
				month: "",
                project: -1,
                cleanOrderNo: "",
                cleanSource: -1,
                isCancel: -1,
			},

			listTotal: 0,
            sourceArrData: Utils.cleanSources(null),
			columns: [
                // {
                //     title: 'ID',
                //     key: 'id',
                //     align: 'center',
                //     width: 100
                // },
				{
                    title: '发生时间',
                    key: 'createDate',
                    align: 'center',
                    width: 110,
					render: (h,params) => {
						return h('div',Moment(params.row.createDate).format('YYYY-MM-DD HH:mm:ss'))
					}
                },
				{
                    title: '项目',
                    key: 'project',
                    align: 'center',
                    width: 80,
                },
				{
                    title: '清洁单号',
                    key: 'cleanOrderNo',
                    align: 'center',
                    width: 280
                },
				{
                    title: '清洁单来源',
                    key: 'cleanSource',
                    align: 'center',
                    width: 120,
                    render: (h,params) => {
						return h('div', Utils.cleanSources(params.row.cleanSource))
					}
                },
				{
                    title: '金额(元)',
                    key: 'costMoney',
                    align: 'center',
                    width: 100,
                    render: (h,params) => {
						return h('div',params.row.costMoney? params.row.costMoney/100:0)
					}
                },
				{
                    title: '原因',
                    key: 'reason',
                    align: 'center',
                },
				{
                    title: '备注',
                    key: 'remark',
                    align: 'center',
                },
                {
                    title: '管理',
                    align: 'center',
                    render: (h, params) => {
                        return h("div", [
                            h(
                                "Button",
                                {
                                    props: {
                                        type: params.row.isCancel?"":"primary",
                                        size: "small"
                                    },
                                    style: {
                                        marginLeft:'10px',
                                    },
                                    on: {
                                        click: () => {
                                            if (!params.row.isCancel) {
                                                this.showCancelRewardFineModal()
                                                this.cancelRewardFineModal.data.id = params.row.id
                                            }
                                        }
                                    }
                                },
                                params.row.isCancel?"已取消":"取消"
                            )
                        ])
                    }
                },
			],
		}
	},

	created() {
		this.token = Utils.findFromLocalStorage('vue-token');
		this.username = Utils.findFromLocalStorage('vue-username');
		this.env = Utils.findFromLocalStorage('env', 'dev');
        this.AuthorToken = Utils.findFromLocalStorage('Author-token');
        this.headerENV = Utils.aliHeaderEnv(this.env)

		this.queryParams.cleanerId = Utils.getUrlParameterByName( 'cleanerId' )
		this.queryParams.month = Utils.getUrlParameterByName( 'month' )

		this.getCleanerChargingBillDetails()
	},

	methods: {
		changePage(pageIndex) {
          this.queryParams.page = pageIndex;
          this.getCleanerChargingBillDetails();
        },
        changePageSize(pageSize) {
            this.queryParams.page = 1;
			this.queryParams.rows = pageSize;
			this.getCleanerChargingBillDetails();
        },
		async getCleanerChargingBillDetails() {
            let submitParams = {
                rows: this.queryParams.rows,
                page: this.queryParams.page,
                month: this.queryParams.month,
                cleanerId: this.queryParams.cleanerId,
            }

            if (this.queryParams.cleanOrderNo.trim()!="") {
                submitParams.cleanOrderNo = this.queryParams.cleanOrderNo
            }

            if (this.queryParams.project!=-1) {
                submitParams.project = this.queryParams.project
            }

            if (this.queryParams.cleanSource!=-1) {
                submitParams.cleanSource = this.queryParams.cleanSource
            }

            if (this.queryParams.isCancel!=-1) {
                submitParams.isCancel = this.queryParams.isCancel
            }
            console.log('submitParams=====', submitParams)
			let res = (await API.omsAPI[this.env].clientServer.xbCleanerChargingBillDetails(submitParams, {
                'x-ca-stage': this.headerENV,
                'Authorization': this.AuthorToken,
            })).data;
			if (res.retCode || res.code !== '0000') {
                this.$Notice.error( {
                title: '错误',
                desc: `获取管家即时账务列表失败：${res.msg}`
                })
                return
            }
            let keeperBillList = new Array()
            keeperBillList.push(res.data.paymentSummary)
            this.keeperBillList = keeperBillList || [];

			this.paydetailList = res.data.xbCleanerChargingBeanList.list || [];
            this.listTotal = res.data.xbCleanerChargingBeanList.rowCount || 0
			console.log(res)
		},
        showEntryRewardAndFineModal() {
            if (!Utils.hasPermission('entryRewardAndFine')) {
                this.$Notice.error({
                title: "无权限操作"
                });
                return
            }
            this.entryRewardAndFineModal.display = true
        },
        async confirmEntryRewardFineFn() {
            let validResult = false;
            this.$refs.entryRewardFineModalForm.validate( valid => {
                validResult = valid
            } );
            if ( !validResult ) {
                this.$refs.entryRewardFineModal.buttonLoading = false;
                return;
            }
            let params = {
                cleanerAccount: this.entryRewardAndFineModal.data.cleanerAccount,
                costMoney: this.entryRewardAndFineModal.data.costMoney * 100,
                reason: this.entryRewardAndFineModal.data.reason,
                project: "",
                createName: this.username
            }
            console.log('params=====', params)
            let res = (await API.omsAPI[this.env].clientServer.entryRewardAndFine(params, {
                'x-ca-stage': this.headerENV,
                'Authorization': this.AuthorToken,
            })).data;
            if (res.retCode || res.code !== '0000') {
                this.$Notice.error( {
                title: '错误',
                desc: `录入奖惩信息失败：${res.msg}`
                })
                return
            }else {
                this.$Notice.success({
                    title: '操作成功'
                })
                this.entryRewardAndFineModal.display =false
                this.entryRewardAndFineModal.data = Object.assign({}, this.entryRewardAndFineModal.initData)
                this.getCleanerChargingBillDetails()
            }
            this.$refs.entryRewardFineModal.buttonLoading = true;
        },
        showCancelRewardFineModal() {
            if (!Utils.hasPermission('cancelRewardOrFine')) {
                this.$Notice.error({
                title: "无权限操作"
                });
                return
            }
            this.cancelRewardFineModal.display = true
        },
        async cancelRewardFineFn() {
            let validResult = false;
            this.$refs.cancelRewardFineModalForm.validate( valid => {
                validResult = valid
            } );
            if ( !validResult ) {
                this.$refs.cancelRewardFineModal.buttonLoading = false;
                return;
            }
            let params = {
                id: this.cancelRewardFineModal.data.id,
                reason: this.cancelRewardFineModal.data.reason,
                operatorName: this.username
            }
            console.log('params====', params)
            let res = (await API.omsAPI[this.env].clientServer.cancelRewardOrFine(params, {
                'x-ca-stage': this.headerENV,
                'Authorization': this.AuthorToken,
            })).data;
            if (res.retCode || res.code !== '0000') {
                this.$Notice.error( {
                title: '错误',
                desc: `取消奖惩操作失败：${res.msg}`
                })
                return
            }else {
                this.$Notice.success({
                    title: '操作成功'
                })
                this.cancelRewardFineModal.display =false
                this.cancelRewardFineModal.data = Object.assign({}, this.cancelRewardFineModal.initData)
                this.getCleanerChargingBillDetails()
            }

        }
	}
}
</script>

<style>
.paydetailList .ivu-table-cell {
  padding-left: 20px;
  padding-right: 0;
}
</style>


// WEBPACK FOOTER //
// src/pages/cleaner/payment-details.vue